import Vue from 'vue'
import Router from 'vue-router'
import ImageTransferApp from '@/views/ImageTransferApp'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/pt/:version/qr/:guid',
      name: 'WithGuid',
      component: ImageTransferApp
    },
    {
      path: '/pt/:version',
      name: 'Home',
      component: ImageTransferApp
    },
    {
      path: '*', redirect: { name: 'Home', params: { version: 'default' } }
    }
  ]
})
